export default
[{
    "name": "Mat Lam Tam",
    "block_no": "0.26",
    "road_no": "3.35",
    "plot_no": "6.33",
    "price": "98145.04",
    "size": "2.31"
  }, {
    "name": "Subin",
    "block_no": "2.82",
    "road_no": "6.40",
    "plot_no": "7.24",
    "price": "729536.91",
    "size": "7.32"
  }, {
    "name": "Matsoft",
    "block_no": "5.69",
    "road_no": "0.40",
    "plot_no": "0.95",
    "price": "283953.72",
    "size": "3.33"
  }, {
    "name": "Otcom",
    "block_no": "5.05",
    "road_no": "3.71",
    "plot_no": "6.70",
    "price": "414588.07",
    "size": "8.42"
  }, {
    "name": "Fixflex",
    "block_no": "6.00",
    "road_no": "0.16",
    "plot_no": "8.68",
    "price": "741545.16",
    "size": "9.88"
  }, {
    "name": "Hatity",
    "block_no": "1.87",
    "road_no": "1.04",
    "plot_no": "0.40",
    "price": "344588.44",
    "size": "5.25"
  }, {
    "name": "Ronstring",
    "block_no": "6.58",
    "road_no": "9.35",
    "plot_no": "1.80",
    "price": "742585.68",
    "size": "1.57"
  }, {
    "name": "Cardify",
    "block_no": "0.57",
    "road_no": "8.42",
    "plot_no": "4.55",
    "price": "112581.07",
    "size": "3.60"
  }, {
    "name": "Regrant",
    "block_no": "5.95",
    "road_no": "0.65",
    "plot_no": "0.75",
    "price": "166084.28",
    "size": "6.67"
  }, {
    "name": "Hatity",
    "block_no": "2.64",
    "road_no": "0.36",
    "plot_no": "8.55",
    "price": "387028.67",
    "size": "3.52"
  }, {
    "name": "Sonair",
    "block_no": "2.61",
    "road_no": "6.60",
    "plot_no": "4.08",
    "price": "418684.30",
    "size": "7.52"
  }, {
    "name": "Sub-Ex",
    "block_no": "2.92",
    "road_no": "3.49",
    "plot_no": "5.54",
    "price": "778312.76",
    "size": "8.07"
  }, {
    "name": "Vagram",
    "block_no": "1.72",
    "road_no": "6.63",
    "plot_no": "1.05",
    "price": "451229.32",
    "size": "4.55"
  }, {
    "name": "Namfix",
    "block_no": "3.79",
    "road_no": "7.55",
    "plot_no": "7.29",
    "price": "954872.57",
    "size": "9.02"
  }, {
    "name": "Stringtough",
    "block_no": "7.79",
    "road_no": "7.94",
    "plot_no": "7.95",
    "price": "331725.90",
    "size": "0.83"
  }]
  